<div class="row">
    <ng-container [ngSwitch]="from()">
        <ng-container *ngSwitchCase="'NEEDS_REVIEW'"><dpqa-needs-review-state></dpqa-needs-review-state></ng-container>
        <ng-container *ngSwitchCase="'GOOD'"><dpqa-good-state></dpqa-good-state></ng-container>
        <ng-container *ngSwitchCase="'BAD'"><dpqa-bad-state></dpqa-bad-state></ng-container>
    </ng-container>
    <dpqa-icon class="arrow" iconName="arrow-right-slim" [iconSize]="1.6" />
    <ng-container [ngSwitch]="to()">
        <ng-container *ngSwitchCase="'GOOD'"><dpqa-good-state></dpqa-good-state></ng-container>
        <ng-container *ngSwitchCase="'BAD'"><dpqa-bad-state></dpqa-bad-state></ng-container>
    </ng-container>
</div>
